import React from "react";
import { PasswordInput, SaveButton, SimpleForm, TextInput, useNotify } from "react-admin";

import useAuthMutations from "../../store/mutations/useAuthMutations";

import useValidators from "../../hooks/useValidators";
import { PASSWORD_RULES_HINT } from "../../constants/passwordRules";

type PasswordFormProps = {
  email: string;
  isFirstSignIn?: boolean;
};

const PasswordForm: React.FC<PasswordFormProps> = ({ email, isFirstSignIn = false }) => {
  const notify = useNotify();
  const { signIn, setPermanentPassword } = useAuthMutations(notify);
  const { password, newPassword } = useValidators();

  const handleSubmit = (fromData: any) => {
    const data = fromData as { email: string; password_digest: string };

    if (isFirstSignIn) {
      setPermanentPassword(data);
    } else {
      signIn(data);
    }
  };

  return (
    <SimpleForm
      className="c-form c-form_password"
      onSubmit={handleSubmit}
      id="c-form_password"
      toolbar={<SaveButton icon={<></>} className="c-form__submit-btn" label="Login" />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <TextInput
        className="c-form__input c-form__input_text"
        label="Email"
        source="email"
        value={`${email}`}
        defaultValue={`${email}`}
        disabled
        style={{ display: "none" }}
      />
      <PasswordInput
        className="email-verify-for__input email-verify-for__input_password"
        label={`${isFirstSignIn ? "Enter your new permanent password" : "Enter your password"}`}
        source="password_digest"
        validate={isFirstSignIn ? newPassword : password}
        helperText={isFirstSignIn ? PASSWORD_RULES_HINT : false}
      />
    </SimpleForm>
  );
};

export default PasswordForm;
